module.exports = __webpack_public_path__ + "static/media/hdfc_icn_landing_card_2.7753557c.png";